
$(document).on('click', '.show_alert_info2', function() {
    $.ajax({
        url: '/alert/get/info',
        type: 'POST',
        data: {
            aid: this.getAttribute('aid'),
        },
        dataType: 'JSON',
        success: function(data) {
            if (data.status === 'success') {
                Swal.fire({
                    title: data.title,
                    html: data.message,
                    width: 700,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });

                $.ajax({
                    url: '/alert/get/list',
                    type: 'POST',
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    data: {
                        _token: $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function(data) {

                        if (data.length) {
                            $('#alerts_count').show();
                            $('#alerts_count_text').show();
                            $('#alerts_count').html(Object.keys(data[0]).length);
                            $('#alerts_count_text').html(Object.keys(data[0]).length);
                            $('#alerts_non').hide();
                        } else {
                            $('#alerts_count').hide();
                            $('#alerts_count_text').hide();
                            $('#alerts_non').show();
                        }

                        $('[data-role="content"]').each((index, el) => {
                            const tabpanel = $(el);
                            const groupNotification = data[index];
                            tabpanel.empty();

                            for (const groupKeyNotification of Object.keys(groupNotification)) {
                              const notification = groupNotification[groupKeyNotification];
                              tabpanel.append(`
                                <a class="list-group-item dropdown-item show_alert_info" aid="${notification.id}" href="javascript:void(0)" role="menuitem">
                                  <div class="media">
                                    <div class="pr-10">
                                      <i class="icon md-info-outline" style="font-size: 14pt" aria-hidden="true"></i>
                                    </div>
                                    <div class="media-body">
                                      <h6 class="media-heading">${notification.title}</h6>
                                      <time class="media-meta" datetime="">${notification.updated}</time>
                                    </div>
                                  </div>
                                </a>
                              `);
                            }
                        });

                    }
                });

            } else {
                Swal.fire({
                    icon: data.status,
                    title: data.title,
                });
            }
        }
    });
});



$(document).on('click', '.alerts_settings_modal', function() {
    Swal.fire({
        title: 'Настройки уведомлений',
        html: '<div class = "text-left"><input type="checkbox" id = "system"> Системные уведомления<br/>' +
            '<input type="checkbox" id = "schedule"> Изменения в расписании<br/>' +
            '<input type="checkbox" id = "sdo"> Система дистанционного обучения<br/>' +
            '<input type="checkbox" id = "asu"> Информационная система управления<br/>' +
            '<input type="checkbox" id = "bookkeeping_ec"> Бухгалтерия<br/></div>',
        showCloseButton: true,
        showConfirmButton: false,
        heightAuto: false,
        onBeforeOpen: () => {
            const system_check = document.getElementById('system');
            const schedule_check = document.getElementById('schedule');
            const sdo_check = document.getElementById('sdo');
            const asu_check = document.getElementById('asu');
            const bookkeeping_ec_check = document.getElementById('bookkeeping_ec');


            function alerts_save_settings(name, check) {
                Swal.showLoading()
                fetch('/alertsupdate?name=' + name + '&check=' + check)
                    .then(response => response.json())
                    .catch(() => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Настройки уведомлений не сохранены!',
                            heightAuto: false,
                        })
                    });
                Swal.hideLoading();
            }

            system_check.addEventListener('click', () => {
                alerts_save_settings('system', system_check.checked)
            });
            schedule_check.addEventListener('click', () => {
                alerts_save_settings('schedule', schedule_check.checked)
            });
            sdo_check.addEventListener('click', () => {
                alerts_save_settings('sdo', sdo_check.checked)
            });
            asu_check.addEventListener('click', () => {
                alerts_save_settings('asu', asu_check.checked)
            });
            bookkeeping_ec_check.addEventListener('click', () => {
                alerts_save_settings('bookkeeping_ec', bookkeeping_ec_check.checked)
            });
        }
    });
});
